import { TopoImageLibrary } from 'topomap/topology/TopoImageLibrary';
import { TopoImageEntry } from 'topomap/topology/TopoImageEntry';
import { TopoMapConfigurationWebService } from './topo-map-configuration.web.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class TopoMapConfigurationService {

    private numTopoImagesLoaded: number;

	public topoImagesLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(private configWebService: TopoMapConfigurationWebService) {
		this.loadTopoImageEntries();
    }

	private loadTopoImageEntries() {
		this.configWebService.getTopoImageEntries().subscribe({
			next: (result: TopoImageEntry[]) => {
				result.forEach((imageEntry: TopoImageEntry) => {
					this.loadTopoImageEntry(imageEntry);
				});
			},
			error: (error?: any) => {
				console.error("Failed to load user topo image map");
				console.error(error);
			}
		});
	}

	private loadTopoImageEntry(imageEntry: TopoImageEntry) {
		var image = new Image();
		this.numTopoImagesLoaded = 0;
		image.onload = async() => {
			imageEntry.image = image;
			TopoImageLibrary.instance.addSystemImage(imageEntry);
			this.numTopoImagesLoaded++;
			if (this.numTopoImagesLoaded === TopoImageLibrary.images.length) {
				TopoImageLibrary.isLoaded = true;
				this.topoImagesLoaded.next(true);
			}
		};

		image.src = `data:image/png;charset=utf-8;base64,${imageEntry.file}`;
	}
}